import { getCacheVal } from '@/services/utils/cacheUtils';

export const isLoggedIn = (): boolean => !!getCacheVal('token');
